<template>
  <!-- pre loader start -->
  <div class="pa-preloader">
      <div class="pa-ellipsis">
          <span></span>
          <span></span>
          <span></span>
      </div>
  </div>
  <!-- pre loader end -->
</template>

<script>
export default {
  name: 'Preloader'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue